import image1 from './1.png'
import image2 from './2.png'

export default [
  image1,
  image2,
]